import type { Uniforms } from "@/types";
import { Color, Texture, Uniform, Vector3 } from "three";

export const buildShaderUniforms = (
  uniformsDefinition: Uniforms,
  textures: {
    [x: string]: Texture;
  },
  dieType: number,
  preview?: boolean,
) => {
  const uniforms: Record<string, Uniform> = {};

  for (const [name, { type, value }] of Object.entries(uniformsDefinition)) {
    switch (type) {
      case "color":
        uniforms[name] = new Uniform(new Color(value));
        break;
      case "texture":
        const texture = textures[value];
        if (texture) {
          uniforms[name] = new Uniform(texture);
        }
        break;
      case "float":
      case "int":
        uniforms[name] = new Uniform(value);
        break;
      default:
        break;
    }
  }

  uniforms.iGlobalTime = new Uniform(0.0);
  uniforms.dieType = new Uniform(dieType);
  uniforms.lastEvent = new Uniform(0);
  uniforms.lastEventTime = new Uniform(0.0);
  uniforms.u_UpAxis = new Uniform(
    preview ? new Vector3(0, 1, 0) : new Vector3(0, 0, 1),
  );

  return uniforms;
};
